import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

const collapsedKey = "mystaff.sidebarCollapsed";

function readCollapsed(): boolean {
  try {
    const stored = localStorage.getItem(collapsedKey);
    if (stored !== null) return stored === "1";
  } catch {
    // ignore
  }
  // Collapse by default on narrow screens.
  return window.matchMedia("(max-width: 1023px)").matches;
}

export function AppLayout() {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(readCollapsed);

  const toggle = () =>
    setCollapsed((c) => {
      try {
        localStorage.setItem(collapsedKey, c ? "0" : "1");
      } catch {
        // ignore
      }
      return !c;
    });

  return (
    <div className="flex min-h-dvh">
      <a
        href="#main"
        className="sr-only z-50 rounded-md bg-primary-solid px-3 py-2 text-white focus:not-sr-only focus:fixed focus:top-2 focus:left-2"
      >
        {t("app.skipToContent")}
      </a>
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main id="main" className="mx-auto w-full max-w-[1440px] flex-1 px-4 py-6 md:px-8 md:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
